import { Controller } from "stimulus"

// Het off-canvas menu op schermen smaller dan 768px (layouts/application).
// Standaard dicht. De hamburger opent het; het kruisje, een klik op de
// donkere achtergrond, Escape of een klik op een link sluiten het weer.
// Bij openen gaat de focus naar het kruisje en blijft Tab binnen het menu;
// bij sluiten gaat de focus terug naar de knop waarmee het geopend werd.
export default class extends Controller {
  static targets = ["paneel", "lade", "achtergrond", "openKnop", "sluitKnop"]

  connect() {
    this.sluit({ focus: false })
    this.bijToets = this.toets.bind(this)
    this.voorCache = () => this.sluit({ focus: false })
    document.addEventListener("turbo:before-cache", this.voorCache)
  }

  disconnect() {
    document.removeEventListener("keydown", this.bijToets)
    document.removeEventListener("turbo:before-cache", this.voorCache)
    document.documentElement.style.overflow = ""
  }

  open(event) {
    if (event) event.preventDefault()
    this.paneelTarget.hidden = false
    this.paneelTarget.setAttribute("aria-hidden", "false")
    this.openKnopTargets.forEach((knop) => knop.setAttribute("aria-expanded", "true"))
    document.documentElement.style.overflow = "hidden"
    document.addEventListener("keydown", this.bijToets)
    // Volgende frame, zodat de overgang van dicht naar open zichtbaar is
    requestAnimationFrame(() => {
      this.paneelTarget.classList.add("is-open")
      if (this.hasSluitKnopTarget) this.sluitKnopTarget.focus()
    })
  }

  sluit(opties = {}) {
    if (!this.hasPaneelTarget) return
    const wasOpen = !this.paneelTarget.hidden
    this.paneelTarget.classList.remove("is-open")
    this.paneelTarget.hidden = true
    this.paneelTarget.setAttribute("aria-hidden", "true")
    this.openKnopTargets.forEach((knop) => knop.setAttribute("aria-expanded", "false"))
    document.documentElement.style.overflow = ""
    document.removeEventListener("keydown", this.bijToets)
    if (wasOpen && opties.focus !== false && this.hasOpenKnopTarget) this.openKnopTarget.focus()
  }

  dicht(event) {
    if (event) event.preventDefault()
    this.sluit()
  }

  // Een link in het menu: sluiten zodat het menu niet open in de cache staat
  // als je terugbladert. Een vergrendeld onderdeel is een knop, geen link, en
  // laat het menu open zodat de melding te lezen is.
  linkGekozen(event) {
    if (event.target.closest("a[href]")) this.sluit({ focus: false })
  }

  toets(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.sluit()
      return
    }
    if (event.key !== "Tab") return

    const focusbaar = Array.from(
      this.ladeTarget.querySelectorAll("a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex='-1'])")
    ).filter((el) => el.offsetParent !== null)
    if (focusbaar.length === 0) return

    const eerste = focusbaar[0]
    const laatste = focusbaar[focusbaar.length - 1]
    if (event.shiftKey && document.activeElement === eerste) {
      event.preventDefault()
      laatste.focus()
    } else if (!event.shiftKey && document.activeElement === laatste) {
      event.preventDefault()
      eerste.focus()
    }
  }
}
